export default{
    homeDownloadtips41: 'व्यापारी ऐप',
    verificationCode: 'सत्यापन कोड',
    pleaseEnterVerificationCode: 'कृपया सत्यापन कोड दर्ज करें',
    pleaseEnterUsername: 'कृपया उपयोगकर्ता नाम दर्ज करें',
    username: 'उपयोगकर्ता नाम',
    getVerificationCode: 'कोड प्राप्त करें',
    tryAgainLater: 'सेकंड बाद पुनः प्रयास करें',
    myComment: 'मेरी समीक्षाएं',
    myPoint: 'मेरे अंक',
    accountInfo: 'खाता जानकारी',
    myBalance: 'मेरी जमा राशि',
    myCoupon: 'मेरे कूपन',
    unused: 'अप्रयुक्त',
    used: 'उपयोग किया गया',
    expired: 'समाप्त',
    expires: 'मान्य अवधि तक',
    minSpend: 'न्यूनतम खर्च',
    availableBalance: 'उपलब्ध शेष',
    personalDeposit: 'जमा राशि',
    useDepositBalance: 'कटौती के लिए जमा राशि का उपयोग करें',
    depositDeduct: 'जमा राशि कटौती',
    useMaxDeposit: 'पूर्ण कटौती',
    balanceHistory: 'शेष इतिहास',
    recordCount: 'कुल {count} रिकॉर्ड',
    depositType: 'लेनदेन प्रकार',
    balanceAfter: 'शेष राशि',
    depositTypeRecharge: 'जमा राशि रिचार्ज',
    depositTypeAdjustment: 'शेष समायोजन',
    depositTypeOrderPayment: 'ऑर्डर भुगतान',
    depositTypeOrderRefunds: 'ऑर्डर वापसी',
    depositTypeDistributionCommission: 'वितरण कमीशन',
    depositTypeDistributionWithdrawal: 'वितरण निकासी',
    depositTypeOther: 'अन्य',
    income: 'आय',
    expense: 'व्यय',
    description: 'विवरण',
    myFootprint: 'मेरे पदचिह्न',
    shop_order_insufficientBalance: 'खाता शेष अपर्याप्त है',
    flashSale: 'फ्लैश सेल',
    groupBuy: 'समूह खरीद',
    groupBuying: 'समूह खरीदारी',
    couponCenter: 'कूपन केंद्र',
    pointMall: 'अंक स्टोर',
    liveList: 'लाइव',
    endsIn: 'समाप्त होने में',
    soldOut: 'बिक गया',
    people: 'लोग',
    joined: 'शामिल हुए',
    startGroup: 'समूह शुरू करें',
    getCoupon: 'प्राप्त करें',
    required: 'यह फ़ील्ड आवश्यक है',
    nickname: 'उपनाम',
    enterNickname: 'कृपया उपनाम दर्ज करें',
    gender: 'लिंग',
    male: 'पुरुष',
    female: 'महिला',
    secret: 'गोपनीय',
    birthday: 'जन्मदिन',
    selectDate: 'तारीख चुनें',
  cancelOrderMap:{
    "0": "मैं यह नहीं चाहता.",
    "1": "उत्पाद को गलत स्थान पर रख दिया",
    "2": "आदेश की प्रतिलिपि",
    "3": "प्राप्त करना विफल रहा",
    "4": "अन्य कारण"
  },
  order: {
    cancel: "आदेश रद्द",
    payment: "अब भुगतान करें",
    confirm: "प्राप्ति की पुष्टि",
    remind: "शिपमेंट के लिए याद दिलाएँ",
    return: " उत्पाद वापसी के लिए अनुरोध",
    evaluate: "अभी समीक्षा करें",
    logistics: "रसद देखें",
    noRefund: "अप्रतिदेय",
    refunding: "धनवापसी प्रगति पर है",
    refundSuccess: "धनवापसी सफल हुई",
    refundFail: "धनवापसी विफल",
        expressCompany: 'कूरियर',
        trackingNo: 'ट्रैकिंग नंबर',
        noOrderShipping: 'कोई शिपिंग जानकारी नहीं',
        noTransitSteps: 'कोई ट्रैकिंग अपडेट नहीं',
        logisticsLoadFail: 'लॉजिस्टिक्स लोड करने में विफल। बाद में पुनः प्रयास करें।',
        remindTitle: "शिपमेंट के लिए याद दिलाएँ",
},
  "暂无数据": "कोई डेटा नहीं",
  "加载中": "लोड हो रहा है",
  "电商批发商场": "थोक मॉल",
  "热销推荐": "जबरदस्त सौदे",
  "用户未发表评论": "उपयोगकर्ता ने कोई टिप्पणी नहीं की है",
  "请输入关键字搜索": "कृपया खोजने के लिए कीवर्ड दर्ज करें",
  "请输入完整的支付密码!": "कृपया पूरा भुगतान पासवर्ड दर्ज करें!",
  "subOrder": "जमा करना",
  "KEY": "英语(एन)",
  "-连接已建立-": "-कनेक्शन स्थापित-",
  ",才可提币": ", और फिर नकदी निकाली जा सकती है।",
  "[code]值错误": "[कोड] मान ग़लत है",
  "[symbol]参数为空": "[प्रतीक] पैरामीटर खाली है",
  "goodsFreightTips1": "1. माल ढुलाई दर फॉर्मूला: माल ढुलाई दर = प्रेषण शुल्क + दूरी + वितरण शुल्क",
  "creditQuotaINFO": "100,000 से 30,000,000 लचीली सीमा और बिना किसी प्रतिबंध के, अधिकतम ऋण अवधि एक वर्ष के साथ।",
  "authentic": "100% मौलिक",
  "homeIconTips1": "100% मौलिक",
  "goodsFreightTips2": "2. यदि डाक की शर्तें पूरी नहीं होती हैं, तो माल ढुलाई लागत वास्तविक परिस्थितियों के अनुसार ली जाएगी।",
  "goodsFreightTips3": "3. अंतिम व्याख्या का अधिकार मंच का है।",
  "dayReturns7": "7 दिन वापसी",
  "homeIconTips2": "7 दिन वापसी",
  "homeIconTips4": "भुगतान सुरक्षित",
  "safe": "सुरक्षित और चिंता मुक्त",
  "safePayment": "भुगतान सुरक्षित",
  "homeDownloadtips4": "एंड्रॉइड के लिए डाउनलोड करें",
  "keep": "बनाए रखना",
  "saveQr": "QR कोड सहेजें",
  "payPal": "पेपैल",
  "coinBlock": "मुद्रा",
  "validatorRequire": "आवश्यक फ़ील्ड खाली नहीं हो सकते",
  "edit": "द्वारा संपादित",
  "markDefaultAddress": "डिफ़ॉल्ट शिपिंग पते के रूप में चिह्नित करें",
  "不能为空": "यह खाली नहीं हो सकता",
  "cancelOrder2": "यह पसंद नहीं है, यह नहीं चाहिए",
  "contactUs1": "यदि आप अपने दोस्तों से पैसे उधार नहीं लेना चाहते हैं, तो कृपया हमसे संपर्क करें।",
  "不在交易时段": "ट्रेडिंग सत्र से बाहर",
  "不在可提现时间内": "निकासी अवधि से बाहर",
  "猜你喜欢": "लगता है तुम्हें यह पसंद है",
  "paramError": "पैरामीटर त्रुटि",
  "参数错误": "पैरामीटर त्रुटि",
  "参数异常，消息获取失败": "पैरामीटर त्रुटि. संदेश प्राप्त करने में विफल",
  "Operate": "संचालन",
  "operationSuccess": "ऑपरेशन सफल हुआ",
  "操作成功": "ऑपरेशन सफल हुआ",
  "操作类型不能小于0": "ऑपरेशन प्रकार 0 से कम नहीं हो सकता",
  "操作类型不是整数": "ऑपरेशन प्रकार पूर्णांक नहीं है",
  "操作类型为空": "ऑपरेशन प्रकार रिक्त है",
  "view": "देखना",
  "Checkorder": "आर्डर देखें",
  "logistics": "रसद देखें",
  "CheckDetails": "विवरण देखें",
  "lowOpinion": "ख़राब समीक्षाएँ",
  "产品不存在": "उत्पाद मौजूद नहीं है",
  "产品剩余数量不足": "उत्पाद की शेष मात्रा अपर्याप्त है",
  "interest": "ब्याज अर्जित करें",
  "dealSuccess": "सफल",
  "successTips": "सफल",
  "beSeller": "विक्रेता बनें",
  "homeBannertips1": "विक्रेता बनें",
  "承兑商不存在": "स्वीकर्ता मौजूद नहीं है",
  "orderCity": "शहर",
  "city": "शहर",
  "程序错误": "प्रोग्राम त्रुटि",
  "持有币种不足": "पर्याप्त फंडिंग नहीं",
  "recharge": "जमा",
  "rechargeSuccessful": "जमा सफल हुआ",
  "rechargeAddress": "जमा पता",
  "rechargeMethod": "जमा मोड",
  "rechargeRecord": "जमा रिकार्ड",
  "充值价值不得大于最大限额": "जमा राशि अधिकतम सीमा सीमा से अधिक नहीं हो सकती",
  "充值价值不得小于最小限额": "जमा राशि न्यूनतम सीमा सीमा से कम नहीं हो सकती",
  "充值金额不能小于1": "जमा राशि 1 (दो दशमलव अंकों सहित) से कम नहीं हो सकती",
  "充值链错误": "जमा लिंक त्रुटि",
  "rechargeNum": "जमा राशि",
  "充值数量不能小于等于0": "जमा राशि 0 से कम या बराबर नहीं हो सकती",
  "rechargeTips": "जमा नोट: कृपया स्थानांतरण राशि सही ढंग से भरें। अन्यथा, सिस्टम अनुमोदन पारित करने में विफल हो सकता है और रिचार्जिंग प्रगति को प्रभावित कर सकता है।",
  "dealing": "प्रक्रिया में",
  "processing": "प्रक्रिया में",
  "ship": "नाव",
  "creditText1": "स्टार्ट-अप लोन पैसे उधार लेने की परेशानी से बचने के लिए है",
  "businessloan": "स्टार्ट-अप ऋण आवेदन",
  "存在不同杠杆的持仓单": "विभिन्न उत्तोलन विकल्प हैं",
  "cancelOrder7": "एक महत्वपूर्ण समस्या है",
  "存在重复的角色名称": "डुप्लिकेट भूमिका नाम",
  "大于最大采购数量": "अधिकतम खरीद राशि से अधिक",
  "代理层级错误": "एजेंट त्रुटि",
  "delivered": "लंबित लदान",
  "pendingPayment": "लंबित भुगतान",
  "待付款的订单无法放行": "लंबित भुगतान जारी करने में असमर्थ",
  "comment": "समीक्षाधीन",
  "receipt": "प्राप्त हो",
  "pending": "लंबित भुगतान",
  "loanHistory": "ऋण रिकार्ड",
  "rates": "ऋण ब्याज दर",
  "term": "ऋण शर्तें",
  "application": "कर्ज के लिए आवेदन",
  "creditWorry": "चिंता मुक्त ऋण",
  "orderUnitprice": "यूनिट मूल्य",
  "当前地址格式错误": "वर्तमान पता गलत प्रारूप में है",
  "当前订单不为待付款状态，无法取消": "वर्तमान आदेश लंबित स्थिति में नहीं है. इसे रद्द नहीं किया जा सकता.",
  "当前还需交易": "लेन-देन अभी भी आवश्यक है",
  "currentRate": "वर्तमान विनिमय दर",
  "sure": "बिल्कुल",
  "当日才可申购": "केवल उसी दिन खरीद के लिए उपलब्ध है",
  "当日可提现次数不足": "प्रति दिन नकदी निकासी की अपर्याप्त संख्या",
  "receivedAddress": "प्राप्तकर्ता का पता",
  "orderAddress": "पता",
  "登陆密码不符合设定": "गलत पासवर्ड",
  "登陆密码长度不符合设定": "गलत पासवर्ड",
  "login": "लॉग इन करें",
  "loginIn": "लॉग इन करें",
  "signIn": "लॉग इन करें",
  "loginSuccess": "सफल हुए",
  "登录过期，请重新登录": "सत्र समाप्त हो गया. कृपया फिर भाग लें",
  "LoginPassword": "लॉगिन पासवर्ड",
  "登录密码必须6-12位": "पासवर्ड 6-12 अक्षर का होना चाहिए",
  "登录密码不能为空": "फ़ील्ड खाली नहीं हो सकती",
  "登录失败": "लॉगिन करने में विफल",
  "clickUpload": "अपलोड करने के लिए क्लिक करें",
  "phoneNumber": "मोबाइल नंबर",
  "电话号码已绑定": "मोबाइल नंबर पहले से ही लिंक है",
  "电话号码已绑定其他用户": "मोबाइल नंबर पहले से ही किसी अन्य उपयोगकर्ता से जुड़ा हुआ है",
  "email": "ईमेल",
  "shopCollection": "स्टोर को पसंदीदा में जोड़ें",
  "订单": "आदेश",
  "trackOrder": "आदेश",
  "订单不存在": "आदेश मौजूद नहीं है",
  "orderTrack": "आदेश पूछताछ",
  "serialNumber": "आदेश संख्या।",
  "orderSummary": "कुल ऑर्डर",
  "cancelOrderSuccess": "रद्द किए गए आदेश",
  "订单退款成功": "वापस किए गए आदेश",
  "订单退款失败": "धनवापसी के लिए विफल आदेश",
  "orderDetails": "ऑर्डर का विवरण",
  "orderInfo": "आदेश की जानकारी",
  "订单已签收": "आदेश प्राप्त हो गया है",
  "订单已取消": "ऑर्डर रद्द कर दिया गया है",
  "订单已取消，无法放行": "आदेश रद्द कर दिया गया है और जारी नहीं किया जा सकता",
  "订单已取消，原因:超时自动取消订单": "प्रतीक्षा अवधि समाप्त होने के कारण ऑर्डर स्वचालित रूप से रद्द कर दिया गया है",
  "订单已取消，原因:手动发起取消订单": "ऑर्डर मैन्युअल रूप से रद्द कर दिया गया है",
  "订单已完成": "ऑर्डर पूरा हो गया",
  "订单已完成，无法放行": "आदेश पूरा हो चुका है और जारी नहीं किया जा सकता",
  "moneyOrderStatus": "आदेश की स्थिति",
  "orderPrefix": "कुल ऑर्डर",
  "subscription": "सदस्यता लें",
  "aboutText2": "सीमा: 100,000-30,000,000, कम ब्याज के साथ लचीली पुनर्भुगतान विधि, कोई अग्रिम शुल्क नहीं, ऑनलाइन ऋण, सत्यापन के लिए कोई फोन कॉल नहीं, गोपनीय जानकारी और उसी दिन ऋण देना।",
  "additional": "अधिक",
  "evaluateOrderSuccess": "समीक्षा सफल हुई",
  "goodsShip": "लदान",
  "发起退款申请": "धनवापसी के लिए अनुरोध",
  "send": "भेजना",
  "发现新版本，请升级到最新版本": "एक नया संस्करण मिला, कृपया नवीनतम संस्करण में अपग्रेड करें",
  "visitStore": "भेंट की दुकान",
  "collAccount": "ऋण विधि",
  "loanMethod": "ऋण विधि",
  "classification": "वर्ग",
  "服务器错误": "सर्वर त्रुटि",
  "服务器错误(500)": "सर्वर त्रुटि (500)",
  "servicePolicy": "सेवा नीति",
  "PaymentOrder": "पेमेंट आर्डर",
  "uploadTips": "भुगतान का प्रमाण (भुगतान विवरण का स्क्रीनशॉट अपलोड करें)",
  "copy": "प्रतिलिपि",
  "copySuccess": "सफलतापूर्वक कॉपी किया गया",
  "该产品未上架": "यह उत्पाद सूचीबद्ध नहीं है",
  "该产品已上市，无法购买": "यह उत्पाद बाज़ार में है और इसे खरीदा नहीं जा सकता",
  "该订单已取消": "इस आदेश को रद्द कर दिया गया है",
  "remindRepeat": "इस आदेश की याद दिलायी गयी है",
  "该广告剩余数量不足": "शेष विज्ञापनों की संख्या अपर्याप्त है",
  "该基金尚未开放购买": "खरीद के लिए फंड नहीं खोला गया है",
  "该基金尚已封闭": "फंड बंद कर दिया गया है",
  "productAvailable": "यह उत्पाद हटा दिया गया है",
  "该邮箱已被订阅": "यह ईमेल पहले ही सब्सक्राइब किया जा चुका है",
  "notOpen": "यह भुगतान विधि आपके क्षेत्र के लिए खुली नहीं है",
  "格式有误:充值金额不能小于1(包含俩位小数)": "प्रारूप गलत है: जमा राशि 1 (दो दशमलव अंकों सहित) से कम नहीं हो सकती",
  "userCenter": "व्यक्तिगत केंद्र",
  "Item": "सामान)",
  "跟单倍数输入错误": "एकाधिक इनपुट त्रुटि",
  "跟单参数输入错误": "एकाधिक इनपुट त्रुटि",
  "more": "अधिक",
  "更新提醒": "अनुस्मारक अद्यतन करें",
  "工作地址不能为空": "फ़ील्ड खाली नहीं हो सकती",
  "homeBannertips2": "कुल कमीशन",
  "orderTotal": "कुल",
  "buyHistory": "खरीद रिकार्ड",
  "购买矿机时间不得低于托管订单剩余时间": "खनन मशीनें खरीदने का समय होस्टिंग ऑर्डर के शेष समय से कम नहीं होना चाहिए",
  "purchageHistory": "खरीद इतिहास",
  "addCartMessageFaild": "उत्पाद पहले से ही आपके शॉपिंग कार्ट में है",
  "fixedRate": "निश्चित ब्याज दर",
  "aboutUs": "हमारे बारे में",
  "about": "हमारे बारे में",
  "followers": "अनुसरण करना",
  "当前余额": "वर्तमान शेष",
  "followedSuccess": "सफल हुए",
  "myFollowedShops": "स्टोर का अनुसरण करें",
  "广告不存在": "विज्ञापन मौजूद नहीं है",
  "广告已下架": "विज्ञापन हटा दिया गया है",
  "orderSpecification": "विनिर्देश",
  "countryOf": "राष्ट्रीयता",
  "areaCode": "अंतर्राष्ट्रीय क्षेत्र कोड",
  "App下载(买家端)": "ऐप डाउनलोड (खरीदार)",
  "App下载(卖家端)": "ऐप डाउनलोड (विक्रेता)",
  "orderNation": "देश",
  "nation": "देश",
  "repayment": "वापसी",
  "repay": "पुनर्भुगतान विधि",
  "reAmount": "चुकौती राशि",
  "cycle": "चुकौती चक्र",
  "loginTips": "क्या आपके पास खाता संख्या नहीं है?",
  "noAccount": "क्या आपके पास खाता संख्या नहीं है?",
  "NoProductSelected": "अभी तक कोई उत्पाद नहीं चुना गया है",
  "shipping": "शिपिंग",
  "highOpinion": "अच्छी समीक्षाएँ",
  "favorableRate": "अच्छी समीक्षाओं की दर",
  "myPraiseRate": "अच्छी समीक्षाओं की दर",
  "totalNum": "कुल",
  "partner": "सहकारी आपूर्तिकर्ता",
  "partnersTit": "पार्टनर - ऑनलाइन ऋण देने वाला प्लेटफार्म",
  "BackHome": "मुखपृष्ठ पर वापस",
  "or": "या",
  "freight": "माल",
  "orderFreight": "माल",
  "getCoupons": "अधिक कूपन प्राप्त करें",
  "基金剩余购买金额不足": "निधि की शेष क्रय राशि अपर्याप्त है",
  "quickLoan": "त्वरित ऋण",
  "records": "अभिलेख",
  "proceed": "जारी रखना",
  "storeSeachTips3": "घर",
  "家庭地址不能为空": "फ़ील्ड खाली नहीं हो सकती",
  "cancelOrder4": "नकली ब्रांड",
  "price": "कीमत",
  "piece": "पीसी",
  "transactionPassword": "लेन-देन पासवर्ड",
  "交易员不存在": "विक्रेता मौजूद नहीं है",
  "交易员不能跟随自己": "विक्रेता स्वयं का अनुसरण नहीं कर सकते",
  "交易员跟随人数已满": "फॉलो करने वाले व्यापारियों की संख्या पूरी है",
  "交易员未开启带单": "विक्रेता ने ऑर्डर नहीं खोला है",
  "交易员无法跟随另一个交易员": "विक्रेता किसी अन्य विक्रेता का अनुसरण नहीं कर सकता",
  "角色被用户关联，不可删除": "भूमिका उपयोगकर्ता द्वारा संबद्ध है. इसे हटाया नहीं जा सकता",
  "角色不存在": "भूमिका मौजूद नहीं है",
  "receiver": "रिसीवर",
  "financial": "अपनी वित्तीय समस्याओं का समाधान करें",
  "successLoan": "ऋण देने की प्रक्रिया सफलतापूर्वक समाप्त हो गई",
  "borrow": "ऋण देने की प्रक्रिया समाप्त होने में विफल रही",
  "loanAgree": "ऋण समझौता",
  "amount": "मात्रा",
  "金额不在购买区间": "राशि क्रय सीमा में नहीं है",
  "validatorMaxNumber": "राशि सीमा सीमा से अधिक है",
  "金额错误": "राशि त्रुटि",
  "validatorChineseAndEnglish": "केवल चीनी और अंग्रेजी भाषाएँ समर्थित हैं; इनपुट सामग्री 8-64 वर्ण है",
  "oldPassword": "पुराना पासवर्ड",
  "旧密码不能为空": "फ़ील्ड खाली नहीं हो सकती",
  "旧密码不正确": "ग़लत पुराना पासवर्ड",
  "可平仓合约张数不足": "करीबी स्थिति अनुबंधों की अपर्याप्त संख्या",
  "service": "ग्राहक सेवा",
  "custService": "ग्राहक सेवा",
  "homeDownloadtips1": "सीमा पार ई-कॉमर्स थोक दुकान",
  "矿机不存在": "खनन मशीन मौजूद नहीं है",
  "矿机未解锁，无法购买": "खनन मशीन बंद है और खरीदी नहीं जा सकती।",
  "From": "से",
  "历史基金无法购买": "पिछले फंड खरीदे नहीं जा सकते",
  "historySearch": "इतिहास खोज",
  "payment": "अब भुगतान करें",
  "buyNow": "अब खरीदें",
  "homeBannerbtn": "अब शामिल हों",
  "evaluate": "अभी समीक्षा करें",
  "连续输入错误三次，请3分钟后再试": "लगातार तीन बार अमान्य इनपुट हुआ. कृपया 3 मिनट में पुनः प्रयास करें",
  "contactUs": "संपर्क करें",
  "twoPawword": "पासवर्ड मेल नहीं खाया",
  "creditQuota": "लचीली सीमा सीमा",
  "retailPrice": "खुदरा मूल्य",
  "领取成功": "सफलतापूर्वक प्राप्त हुआ",
  "pageviews": "देखे जाने की संख्या",
  "myPageviews": "देखे जाने की संख्या",
  "buyRules": "क्रेता के नियम",
  "买入金额需要在区间内": "खरीद राशि सीमा में होनी चाहिए",
  "卖方无法取消该订单": "विक्रेता ऑर्डर रद्द नहीं कर सकता",
  "cancelOrder3": "विक्रेता ने ग़लत माल भेजा",
  "sellerRules": "विक्रेता की नीति",
  "noDataFound": "डाटा प्राप्त नहीं हुआ",
  "没有找到用户": "कोई उपयोगकर्ता नहीं मिला",
  "dailyNewArrival": "दैनिक सौदे",
  "password": "पासवर्ड",
  "密码必须6-12位": "पासवर्ड 6-12 अक्षर का होना चाहिए",
  "密码不能为空": "फ़ील्ड खाली नहीं हो सकती",
  "密码不正确": "गलत पासवर्ड",
  "wrongPassword": "प्रयासों की संख्या 3 गुना से अधिक है. कृपया कल फिर से प्रयास करें",
  "validatorPassword": "पासवर्ड 6-12 अक्षरों और अंकों का होना चाहिए (विशेष अक्षर शामिल हैं)",
  "goodsFreeShipping": "निःशुल्क",
  "orderName": "नाम",
  "defaultAddress": "डिफ़ॉल्ट पता",
  "noCartTips": "आपकी खरीदारी की टोकरी खाली है। खरीदारी शुरू करें",
  "notLogin": "आपने अभी तक लॉग इन नहीं किया है.",
  "unSelectedProduct": "आपने कोई उत्पाद नहीं चुना है",
  "evaluationUploading": "तस्वीरें अभी भी अपलोड की जा रही हैं. कृपया बाद में पुन: प्रयास करें",
  "您当前可分配额度不足": "आपकी वर्तमान आवंटन योग्य सीमा पर्याप्त नहीं है",
  "yourEmail": "आपका ईमेल पता",
  "您没有符合条件的收款方式": "आपके पास कोई योग्य भुगतान विधि नहीं है",
  "您已存在订单": "आपके पास एक आदेश है",
  "您已购买过体验矿机,不得重复购买": "आपने पहले ही अनुभव खनन मशीन खरीद ली है। इसे दोबारा न खरीदें",
  "photoExample": "फोटो उदाहरण",
  "homeDownloadtips2": "बिक्री पर ब्रांड",
  "Evaluate": "समीक्षा",
  "evaluateOrder": "चित्रों के साथ समीक्षाएँ",
  "evaluateInput": "चित्रों के साथ समीक्षाएँ",
  "homeDownloadtips5": "एप्पल के लिए डाउनलोड करें",
  "cancelOrder9": "अन्य कारण",
  "businessPhone": "स्टोर संपर्क नंबर",
  "businessEmail": "कॉर्पोरेट ईमेल",
  "walletHistory": "बटुआ इतिहास",
  "亲属地址不能为空": "फ़ील्ड खाली नहीं हो सकती",
  "亲属电话不能为空": "फ़ील्ड खाली नहीं हो सकती",
  "亲属关系不能为空": "फ़ील्ड खाली नहीं हो सकती",
  "亲属姓名不能为空": "फ़ील्ड खाली नहीं हो सकती",
  "empty": "खाली",
  "evaluateOrderPlaceholder": "कृपया उत्पाद की समीक्षा करें",
  "checkAgreement": "कृपया समझौता स्वीकार करें!",
  "请检查网络连接": "कृपया अपना नेटवर्क कनेक्शन जांचें",
  "returnDetailTips": "कृपया उत्पाद के बारे में समीक्षा दें",
  "switchLang": "जाँच करने के लिए कृपया दूसरी भाषा पर स्विच करें",
  "请切换其他语言后查看": "जाँच करने के लिए कृपया दूसरी भाषा पर स्विच करें",
  "请上传图片": "कृपया चित्र अपलोड करें",
  "uploadPhoto": "कृपया फ़ोटो अपलोड करें",
  "请稍后再试": "कृपया बाद में पुन: प्रयास करें",
  "请稍后重试": "कृपया बाद में पुन: प्रयास करें",
  "pleaseSetLoginPassword": "कृपया लॉगिन पासवर्ड दर्ज करें",
  "pleaseSetMobileNumber": "मोबाइल नंबर दर्ज करें",
  "pleaseEnterPhoneNumer": "मोबाइल नंबर दर्ज करें",
  "plaeseEnterInvitaionCode": "कृपया आमंत्रण कोड दर्ज करें",
  "pleaseEnterEmail": "कृपया ईमेल दर्ज करें",
  "enterTips": "कृपया दर्ज करें",
  "pleaseInput": "कृपया दर्ज करें",
  "validatorFourMoreNumber": "कृपया 4 से अधिक अक्षर दर्ज करें",
  "pleaseValidPostCode": "कृपया 4 से अधिक अक्षर दर्ज करें",
  "validatorSixNumber": "कृपया 6 अक्षर दर्ज करें",
  "请输入充值币种": "कृपया जमा मुद्रा दर्ज करें",
  "plaseEnterRechargeAddress": "कृपया जमा पता दर्ज करें",
  "pleaseEnterAmount": "कृपया जमा राशि दर्ज करें",
  "pleaseInputCorrectNumber": "कृपया 0 से बड़ी संख्या दर्ज करें",
  "pleaseEnterAddress": "कृपया पता दर्ज करें",
  "headerSearchTips": "कृपया खोजने के लिए कीवर्ड दर्ज करें",
  "pleaseEnterOldPassword": "कृपया पुराना पासवर्ड दर्ज करें",
  "pleaseEnterPassword": "कृपया पासवर्ड दर्ज करें",
  "请输入内容": "कृपया सामग्री दर्ज करें",
  "plaseeENterConfirmPassword": "कृपया पुष्टिकरण पासवर्ड दर्ज करें",
  "pleaseEnterQuantity": "कृपया राशि दर्ज करें",
  "请输入搜索关键字": "कृपया खोजने के लिए कीवर्ड दर्ज करें",
  "withdrawInputTips": "कृपया निकासी पता दर्ज करें",
  "plaseeEnterNewPassword": "कृपया नया पासवर्ड दर्ज करें",
  "yourName": "कृपया नाम दर्ज करें",
  "pleaseEnterAccount": "कृपया खाता संख्या दर्ज करें",
  "请输入正确的货币数量": "कृपया सही मात्रा दर्ज करें",
  "请输入正确的金额": "कृपया सही मात्रा दर्ज करें",
  "validatorPhone": "कृपया सही मोबाइल नंबर दर्ज करें",
  "pleaseValidPhone": "कृपया सही मोबाइल नंबर दर्ज करें",
  "请输入正确的数量": "कृपया सही मात्रा दर्ज करें",
  "inpuEmailErro": "कृपया सही ईमेल पता दर्ज करें",
  "pleaseValidEmail": "कृपया सही ईमेल पता दर्ज करें",
  "validatorEmail": "कृपया ईमेल को सही प्रारूप में दर्ज करें",
  "请输入正确的质押金额": "कृपया सही प्रतिज्ञा राशि दर्ज करें",
  "请输入正确的质押天数": "कृपया गिरवी रखने के दिनों की सही संख्या दर्ज करें",
  "pleaseCorrectAddress": "कृपया सही निकासी पता दर्ज करें",
  "请填写正确的电话号码": "कृपया सही मोबाइल नंबर दर्ज करें",
  "请填写正确的验证码": "कृपया सही सत्यापन कोड दर्ज करें",
  "mailboxCheck": "कृपया सही ईमेल पता दर्ज करें",
  "请填写正确的邮箱地址": "कृपया सही ईमेल पता दर्ज करें",
  "请先绑定谷歌验证器": "कृपया पहले Google प्रमाणक को आबद्ध करें",
  "请先添加收款方式": "कृपया पहले भुगतान विधि जोड़ें",
  "请先通过高级认证": "कृपया पहले उन्नत प्रमाणीकरण पास करें",
  "cancelOrderTitle": "कृपया ऑर्डर रद्द करने का कारण चुनें",
  "selectCountry": "कृपया एक राष्ट्रीयता चुनें",
  "请选择买卖方式": "कृपया भुगतान विधि चुनें",
  "selectPeriod": "कृपया एक अवधि चुनें",
  "returnOrderTitle": "कृपया वापसी का कारण चुनें",
  "请选择正确的币种": "कृपया सही मुद्रा चुनें",
  "请重新登录": "कृपया फिर भाग लें",
  "blockchainNetwork": "ब्लॉकचेन नेटवर्क",
  "渠道未开通": "चैनल नहीं खुला",
  "Cancel": "रद्द करना",
  "取消": "रद्द करना",
  "cancelSuccess": "सफलतापूर्वक रद्द किया गया",
  "cancelOrder": "आदेश रद्द",
  "cancel": "आदेश रद्द",
  "CancelOrder": "आदेश रद्द",
  "myUnfollow": "करें",
  "cancelReason": "रद्द करने का कारण",
  "all": "सभी को देखें",
  "AllProducts": "सभी प्रोडक्ट",
  "btnSure": "पुष्टि करना",
  "确认": "सत्यापित करें",
  "entRepay": "भुगतान की पुष्टि करें",
  "confirmPayPaw": "लेनदेन पासवर्ड की पुष्टि करें",
  "confirmPassword": "पासवर्ड की पुष्टि कीजिये",
  "delAllHistoryRecord": "क्या आप वाकई सभी इतिहास रिकॉर्ड हटाना चाहते हैं?",
  "confirm": "प्राप्ति की पुष्टि",
  "date": "तारीख",
  "scanAndDown": "ऐप डाउनलोड करने के लिए QR कोड स्कैन करें",
  "homeDownloadtips6": "ऐप डाउनलोड करने के लिए QR कोड स्कैन करें",
  "delete": "मिटाना",
  "sellerPanelLogin": "विक्रेता लॉगिन",
  "merchantSettled": "साझेदारी",
  "sellerZone": "व्यापारिक क्षेत्र",
  "商家已确认，已进入备货状态": "विक्रेता की पुष्टि हो गई है और उसने स्टॉकिंग प्रक्रिया शुरू कर दी है",
  "commodity": "उत्पाद",
  "orderCommodity": "उत्पाद",
  "commodityCollection": "उत्पाद संग्रह",
  "productDescription": "उत्पाद वर्णन",
  "myCommodityCollection": "पसंदीदा उत्पाद",
  "goodsNumber": "उत्पाद मात्रा",
  "goodsShipTips": "ऑर्डर देने के बाद इसे 24 घंटे के भीतर भेज दिया जाएगा। शिपिंग का समय लॉजिस्टिक्स पर निर्भर करता है और इसे लंबा किया जा सकता है। कृपया लॉजिस्टिक्स जानकारी पर ध्यान दें या ग्राहक सेवा से संपर्क करें",
  "productInfo": "उत्पाद की जानकारी",
  "uploadSuccess": "सफलतापूर्वक अपलोड किया गया",
  "uploadError": "अपलोड करने में विफल, कृपया पुनः प्रयास करें",
  "uploading": "अपलोड हो रहा है...",
  "upNew": "नये उत्पाद",
  "previous": "पिछला कदम",
  "prevPage": "पिछला पृष्ठ",
  "cancelOrder5": "कम शिपमेंट, मिस्ड शिपमेंट",
  "desc": "डिफ़ॉल्ट पते के रूप में सेट करें",
  "setAsTheDefaultAddress": "डिफ़ॉल्ट पते के रूप में सेट करें",
  "setUp": "स्थापित करना",
  "setSuccess": "सेटअप सफल हुआ",
  "setUpPayPaw": "लेनदेन पासवर्ड सेट करें",
  "setPassword": "सांकेतिक शब्द लगना",
  "申购数量错误": "खरीद की राशि गलत है",
  "申请成功": "सफल हुए",
  "applyLoan": "एक ऋण के लिए आवेदन",
  "applicationAmount": "अनुरोध राशि",
  "noSmaller": "अनुरोधित राशि से कम नहीं हो सकती",
  "nomax": "अनुरोधित राशि से अधिक नहीं हो सकती",
  "applicant": "आवेदक",
  "applicantDate": "आवेदन तिथि",
  "return": "उत्पाद वापसी के लिए अनुरोध",
  "applicantIn": "आवेदन प्रगति पर है",
  "身份证已实名过!": "आईडी कार्ड सत्यापित हो गया है!",
  "审核已通过": "अनुमत",
  "审核中": "समीक्षा के अंतर्गत",
  "state": "प्रांत/राज्य/क्षेत्र",
  "dealFail": "असफल",
  "fail": "असफल",
  "orderTime": "समय",
  "time": "समय",
  "ActualLedger": "वास्तविक प्राप्त हुआ",
  "actualAccount": "वास्तविक लेखा",
  "实名认证未通过，无法进行高级认证": "प्रमाणीकरण विफल होना; उन्नत प्रमाणीकरण करने में असमर्थ",
  "confirmReceiveGoods": "उत्पाद की प्राप्ति की पुष्टि करें",
  "collect": "पसंदीदा",
  "collectionSuccess": "पसंदीदा में सफलतापूर्वक जोड़ा गया",
  "wishlist": "पसंदीदा उत्पाद",
  "cancelOrder6": "क्षतिग्रस्त उत्पाद प्राप्त हुआ",
  "desc5": "गलत शिपिंग पता? संपर्क",
  "consigneeName": "प्राप्तकर्ता का नाम",
  "shippingAddress": "प्राप्तकर्ता का पता",
  "收款方输入错误": "इनपुट त्रुटि",
  "购物车还没有商品": "आपकी खरीदारी की टोकरी खाली है",
  "去购物": "खरीदारी शुरू करें",
  "mobile": "मोबाइल नहीं है।",
  "mobilePhone": "मोबाइल नंबर",
  "handleFee": "सेवा शुल्क",
  "handlingFee": "सेवा शुल्क",
  "home": "घर",
  "授权状态未成功": "प्राधिकरण स्थिति विफल",
  "pleaseSetAreaCode": "खोजने के लिए देश का नाम और क्षेत्र कोड दर्ज करें",
  "searchCountry": "खोजने के लिए देश का नाम और क्षेत्र कोड दर्ज करें",
  "desc3": "लेनदेन पासवर्ड दर्ज करें",
  "desc4": "अपना लेनदेन पासवर्ड दर्ज करें",
  "赎回状态异常": "मोचन स्थिति असामान्य",
  "quantity": "मात्रा",
  "orderAmount": "मात्रा",
  "orderQuantity": "मात्रा",
  "inputNum": "नंबर",
  "orderTax": "कर",
  "orderFee": "करों",
  "tax": "कर लगाना",
  "delivery": "वितरण एवं संग्रहण",
  "storeSeach": "इस स्टोर में उत्पाद खोजें",
  "search": "खोज",
  "所选汇率不存在": "चयनित विनिमय दर मौजूद नहीं है",
  "allProduct": "सभी प्रोडक्ट",
  "提币数量不能小于等于0": "निकासी राशि 0 से कम या उसके बराबर नहीं हो सकती",
  "creditText2": "स्टार्ट-अप ऋण और पूंजी कारोबार सेवाएं प्रदान करें",
  "returnOrderSuccess": "सफलतापूर्वक जमा",
  "Submitareview": "समीक्षाएँ सबमिट करें",
  "submitApplica": "आवेदन जमा करें",
  "提交失败": "सबमिशन विफल",
  "提交失败，当前有未处理订单": "सबमिशन विफल. फिलहाल खुले ऑर्डर हैं",
  "hint": "बख्शीश",
  "提示": "बख्शीश",
  "withdraw": "निकालना",
  "提现不得大于限额": "नकद निकासी सीमा से अधिक नहीं हो सकती",
  "提现不得小于限额": "नकद निकासी सीमा से कम नहीं हो सकती",
  "withdrawSuccess": "ऑर्डर सफलतापूर्वक सबमिट किए गए",
  "withdrawAddress": "निकासी का पता",
  "withdrawRecord": "निकासी रिकार्ड",
  "withdrawNum": "निकासी की मात्रा",
  "tipsRemindsSuccess": "अनुस्मारक सफल हुआ",
  "remindSuccess": "अनुस्मारक सफल हुआ",
  "RemindShip": "भेजने के लिए याद दिलाएँ",
  "remind": "शिपमेंट के लिए याद दिलाएँ",
  "remindTitle": "शिपमेंट के लिए याद दिलाएँ",
  "tipsRemindsText": "उत्पादों की शिपिंग के बाद, विक्रेता को एक अधिसूचना मिलेगी",
  "remindContent": "उत्पादों की शिपिंग के बाद, विक्रेता को केवल एक बार अधिसूचना मिलेगी",
  "tipsRemindsMerchant": "विक्रेता को याद दिलाएं",
  "days": "दिन",
  "addCartMessage": "आपके शॉपिंग कार्ट में सफलतापूर्वक जोड़ा गया",
  "addAddress": "नया पता जोड़ें",
  "addAddressOrModifyAddress": "नया पता जोड़ें/पता बदलें",
  "addCart": "शॉपिंग कार्ट में जोड़ें",
  "图片不得大于10M": "किसी छवि के लिए फ़ाइल का आकार 10M से बड़ा नहीं हो सकता",
  "图片不得大于2M": "किसी छवि के लिए फ़ाइल का आकार 2M से बड़ा नहीं हो सकता",
  "图片大小不能超过2M！": "किसी छवि के लिए फ़ाइल का आकार 2M से अधिक नहीं हो सकता!",
  "图片上传失败": "छवि अपलोड करने में विफल",
  "recommendclass": "वर्गों के अनुसार खरीदारी",
  "recommend": "अनुशंसा करना",
  "recommendedProducts": "लोकप्रिय आइटम",
  "recommendedStore": "लोकप्रिय स्टोर",
  "推荐码不正确": "अनुशंसा कोड ग़लत है",
  "推荐人无权限推荐": "अनुशंसा करने का कोई अधिकार नहीं",
  "推荐商品": "लोकप्रिय आइटम",
  "logout": "लॉग आउट",
  "returnsAndEx": "रिटर्न और एक्सचेंज",
  "returnAmount": "वापसी राशि",
  "returnRemark": "वापसी निर्देश",
  "returnPolicy": "वापसी नीति",
  "Refund": "धनवापसी",
  "refund": "रिफंड/बिक्री के बाद",
  "退款成功": "धनवापसी सफल हुई",
  "refundSuccessfully": "धनवापसी सफल हुई",
  "refundSuccess": "धनवापसी सफल हुई",
  "returnReason": "वापसी का कारण",
  "returnApply": "धन वापस करने का अनुरोध",
  "退款失败": "धनवापसी विफल",
  "refundFail": "धनवापसी विफल",
  "refundInstructions": "धनवापसी निर्देश",
  "refunding": "धनवापसी प्रगति पर है",
  "mastercard": "मास्टर कार्ड",
  "EsShop": "ऑनलाइन स्टोर",
  "ForgotPassword": "पासवर्ड भूल गए?",
  "委托数量(张)必填": "सौंपी गई मात्रा (पीसी) आवश्यक है",
  "委托数量(张)不能小于等于0": "सौंपी गई मात्रा (पीसी) 0 से कम या उसके बराबर नहीं हो सकती",
  "foryourmoney": "आपकी वित्तीय समस्याओं को हल करने के लिए ऑनलाइन ऋण एक सुविधाजनक और तेज़ विकल्प है। आपको दोस्तों से पैसे उधार लेने जैसी शर्मिंदगी महसूस नहीं होगी। हमारी पेशेवर टीम आपको प्रक्रिया से गुजरने और किसी भी समय आपके संदेह दूर करने में मदद करेगी। हमारा लक्ष्य अपने ग्राहकों को हर ऋण शीघ्र, पारदर्शी और सुरक्षित रूप से देना है।",
  "storeSeachTips1": "अपने लिए खोजें",
  "未绑定谷歌验证器": "Google प्रमाणक लिंक नहीं किया गया है",
  "未绑定手机号": "मोबाइल नंबर नहीं जोड़ा गया है",
  "未绑定邮箱": "ईमेल नहीं जोड़ा गया है",
  "未发现授权记录": "प्राधिकरण रिकार्ड नहीं मिला है",
  "notQua": "आवश्यकताओं को पूरा नहीं किया",
  "ShippingAddressNotSet": "शिपिंग पता सेट नहीं किया गया है",
  "未实名认证，是否认证？": "वास्तविक नाम से प्रमाणित नहीं. प्रमाणित करें?",
  "cancelOrder1": "उत्पाद प्राप्त नहीं हुआ है",
  "未授权访问": "अनधिकृत पहुंच",
  "noRefund": "अप्रतिदेय",
  "未找到符合条件的匹配订单": "कोई मिलान आदेश नहीं मिला",
  "未找到匹配的收益记录": "कोई मिलान राजस्व रिकॉर्ड नहीं मिला",
  "mine": "मेरा",
  "myloan": "मेरा ऋण",
  "myOrder": "मेरे आदेश",
  "myCart": "मेरी शॉपिंग कार्ट",
  "我的购物车": "मेरी शॉपिंग कार्ट",
  "myPurse": "मेरा बटुआ",
  "myAccount": "मेरा खाता",
  "aboutText1": "हम ग्राहक पहले आएं के व्यावसायिक दर्शन के आधार पर ऋण सेवाएं प्रदान करते हैं, जिसका उद्देश्य ग्राहकों की पूंजीगत वित्तीय समस्याओं का समाधान करना है। कंपनी की स्थापना के बाद से, हमने कई ग्राहकों को उनकी पूंजी टर्नओवर की समस्याओं को हल करने में मदद की है।",
  "readAndAgree": "मैंने पढ़ लिया है और स्वीकार कर लिया है",
  "safeInfo": "कोई बंधक, कोई जमा, और कोई कॉलबैक की आवश्यकता नहीं है। यह एक निजी मामला है.",
  "无权限": "आज्ञा नहीं है",
  "无效的UID": "अमान्य यूआईडी",
  "item": "वस्तु",
  "系统参数错误": "सिस्टम पैरामीटर त्रुटि",
  "系统存在相同[系统登录名]！": "सिस्टम में समान लॉगिन नाम के साथ एक अन्य उपयोगकर्ता पहले से मौजूद है",
  "系统错误，请稍后重试": "सिस्टम त्रुटि, कृपया बाद में पुनः प्रयास करें",
  "系统发货成功": "सफल हुए",
  "系统默认好评": "डिफ़ॉल्ट रूप से अच्छी समीक्षाएँ",
  "defaultRate": "डिफ़ॉल्ट रूप से अच्छी समीक्षाएँ",
  "checkout": "एक आदेश दें",
  "下单不能小于最小金额限制": "ऑर्डर प्लेसमेंट राशि न्यूनतम सीमा से कम नहीं हो सकती",
  "下单成功，等待付款": "ऑर्डर सफलतापूर्वक दे दिया गया है और हम भुगतान की प्रतीक्षा कर रहे हैं",
  "下单成功，付款成功": "भुगतान सफल हुआ",
  "buyTips": "ऑर्डर देने के बाद इसे 24 घंटे के भीतर भेज दिया जाएगा। शिपिंग का समय लॉजिस्टिक्स पर निर्भर करता है और इसे लंबा किया जा सकता है। कृपया लॉजिस्टिक्स जानकारी पर ध्यान दें या ग्राहक सेवा से संपर्क करें।",
  "nextPage": "अगला पृष्ठ",
  "stateMent": "आधुनिक गुलामी वक्तव्य",
  "storeSeachTips2": "संबंधित स्टोर मिले",
  "address": "विस्तृत पता",
  "items": "वस्तु",
  "browse": "कुल बिक्री",
  "sold": "बिका हुआ",
  "sales": "कुल बिक्री",
  "校验IP不合法": "सत्यापन आईपी अमान्य है",
  "new": "नया",
  "newPassword": "नया पासवर्ड",
  "新密码不能为空": "फ़ील्ड खाली नहीं हो सकती",
  "新密码不一致": "पासवर्ड मेल नहीं खाता",
  "新密码确认不能为空": "फ़ील्ड खाली नहीं हो सकती",
  "news": "समाचार",
  "addNewAddress": "नया पता जोड़ें",
  "creditTit": "क्रेडिट ऋण सेवा",
  "Information": "जानकारी",
  "行情获取异常，稍后再试": "उद्धरण असामान्य है, कृपया बाद में पुनः प्रयास करें",
  "modifyAddress": "पता बदलाव",
  "handlingfee": "सेवा शुल्क आवश्यक है",
  "Opt": "चुनना",
  "selectDeliveryAddress": "एक शिपिंग पता चुनें",
  "验证类型不能为空": "फ़ील्ड खाली नहीं हो सकती",
  "验证码不能为空": "फ़ील्ड खाली नहीं हो सकती",
  "验证码不正确": "ग़लत सत्यापन कोड",
  "验证码错误": "सत्यापन कोड त्रुटि",
  "vcodeFail": "सत्यापन में विफल रहा है। पुन: प्रयास करें",
  "vcodePass": "सत्यापित!",
  "invitationCode": "आमंत्रण संकेत",
  "页码不能小于等于0": "पृष्ठ संख्या 0 से कम या उसके बराबर नहीं हो सकती",
  "页码不是整数": "पृष्ठ संख्या पूर्णांक नहीं है",
  "dashboard": "डैशबोर्ड",
  "loaned": "उधार",
  "loanDays": "अवधि",
  "已发货，正在运输中": "परिवहन में भेज दिया गया",
  "followed": "पालन ​​किया",
  "repaid": "वापसी",
  "已领取": "प्राप्त",
  "rated": "समीक्षित",
  "cancelled": "रद्द",
  "confirmed": "की पुष्टि",
  "harvested": "प्राप्त",
  "mySold": "बिका हुआ",
  "overdue": "अतिदेय",
  "privacyPolicy": "गोपनीयता नीति",
  "用户不存在": "उपभोक्ता अस्तित्व मे नहीं है",
  "用户名必须由数字和英文字母组成": "उपयोगकर्ता नाम में संख्याएँ और अक्षर शामिल होने चाहिए",
  "用户名不存在": "उपभोक्ता अस्तित्व मे नहीं है",
  "用户名不符合设定": "उपयोगकर्ता नाम मेल नहीं खाता",
  "用户名不能为空": "फ़ील्ड खाली नहीं हो सकती",
  "用户名参数为空": "फ़ील्ड खाली नहीं हो सकती",
  "用户名重复": "उपयोगकर्ता नाम कॉपी करें",
  "userEvaluation": "उपयोगकर्ता समीक्षा",
  "用户剩余数量不足": "उपयोगकर्ताओं की अपर्याप्त संख्या",
  "用户已跟随交易员": "उपयोगकर्ता स्टोर का अनुसरण कर रहा है",
  "user_Center": "उपयोगकर्ता केंद्र",
  "userReg": "उपयोगकर्ता पंजीकरण",
  "postCode": "डाक कोड",
  "orderEmail": "ईमेल",
  "邮箱已绑定": "ईमेल पहले ही बाध्य किया जा चुका है",
  "邮箱已绑定其他用户": "ईमेल पहले ही किसी अन्य उपयोगकर्ता के लिए बाध्य हो चुका है",
  "orderPostCode": "डाक कोड",
  "hasImage": "चित्रों के साथ",
  "Balance": "संतुलन",
  "balance": "शेष राशि (यूएसडीटी)",
  "余额不足": "अपर्याप्त शेषराशि",
  "balanceNot": "शेष राशि पर्याप्त नहीं है, कृपया जमा करें",
  "cancelOrder8": "विक्रेता के साथ धनवापसी पर बातचीत करें",
  "expectedArrival": "अपेक्षित आगमन",
  "esRepayment": "अनुमानित चुकौती",
  "estirepay": "अनुमानित चुकौती",
  "originPrice": "असली कीमत",
  "deliveryFee": "परिवहन",
  "goodsFreight": "परिवहन",
  "shippingDiscounts": "माल ढुलाई में छूट",
  "homeIconTips3": "माल ढुलाई में छूट",
  "desc6": "अपना लेनदेन पासवर्ड दोबारा दर्ज करें",
  "rebuy": "एक और आदेश",
  "onlineService": "ऑनलाइन सेवाओं",
  "customeService": "ऑनलाइन ग्राहक सेवा",
  "helpLine": "ऑनलाइन ग्राहक सेवा",
  "onlineApplin": "ऑनलाइन आवेदन",
  "暂无店铺": "कोई दुकान नहीं मिली",
  "noComments": "अब तक कोई टिप्पणी नहीं",
  "noData": "डाटा प्राप्त नहीं हुआ",
  "帐户异常需要进行C3认证，请联系在线客服。": "खाता अपवाद के लिए C3 प्रमाणीकरण की आवश्यकता है. कृपया ऑनलाइन ग्राहक सेवा से संपर्क करें।",
  "account": "खाता",
  "accountBalance": "खाते में शेष",
  "accountB": "खाते में शेष",
  "accountReview": "खाता अवलोकन",
  "Recruitment": "करियर",
  "找不到用户": "उपयोगकर्ता नहीं मिला",
  "searchTips": "ब्रांड/उत्पाद/आपूर्तिकर्ताओं की खोज करें",
  "discount": "छूट",
  "homeDownloadtips3": "नॉन-स्टॉप छूट",
  "discounted": "छूट",
  "actualName": "पूरा नाम",
  "passPortImg": "आईडी/पासपोर्ट नंबर",
  "uploadId": "आईडी/पासपोर्ट फोटो अपलोड करें",
  "Payment": "भुगतान",
  "pay": "भुगतान",
  "paymentSuccessful": "भुगतान सफल हुआ",
  "paymentMethod": "भुगतान की विधि",
  "paymethods": "भुगतान की विधि",
  "payCertificate": "भुगतान प्रमाण - पत्र",
  "直线关系，不能修改推荐": "सीधी रेखा संबंध, अनुशंसा को संशोधित नहीं किया जा सकता",
  "tipsRemindsCount": "केवल एक बार याद दिलाया जा सकता है",
  "committed": "हम उद्यमियों को ऋण सेवाएं प्रदान करने के लिए समर्पित हैं",
  "mediumOpinion": "औसत समीक्षाएँ",
  "sort": "प्रकार",
  "重复提交": "पुनः सबमिट करें",
  "Reapply": "पुनः लागू करें",
  "register": "पंजीकरण करवाना",
  "signUp": "पंजीकरण करवाना",
  "registerSuccess": "पंजीकरण सफल हुआ",
  "转账币种不能为空": "फ़ील्ड खाली नहीं हो सकती",
  "转账数量不能小于等于0": "स्थानांतरण राशि 0 से कम या उसके बराबर नहीं हो सकती",
  "orderStatus": "स्थिति",
  "orderState": "स्थिति",
  "状态不能小于0": "स्थिति 0 से कम नहीं हो सकती",
  "状态不是整数": "स्थिति एक पूर्णांक नहीं है",
  "资金密码必须6-12位": "फंड पासवर्ड 6-12 अक्षर का होना चाहिए",
  "资金密码不符合设定": "फंड पासवर्ड मेल नहीं खाता",
  "资金密码不能为空": "फ़ील्ड खाली नहीं हो सकती",
  "资金密码错误": "फंड पासवर्ड त्रुटि",
  "资金密码长度不符合设定": "पासवर्ड की लंबाई सेटिंग्स से मेल नहीं खाती",
  "complex": "अंदाज़ करना",
  "totalOf": "कुल",
  "totalPrice": "कुल कीमत",
  "homeBannertips3": "अधिकतम.",
  "creditReview": "जल्द से जल्द एक घंटे में ऑडिट पास करें। यदि समीक्षा पारित हो जाती है, तो ऋण तुरंत जारी कर दिया जाएगा।",
  "yesterday": "कल",
  "binance": "बायनेन्स",
  "huobi": "हुओबी",
  "validatorIpRule": "ग़लत आईपी पता",
  "metaMask": "मेटामास्क",
  "footTip": "{name} लिमिटेड 2024। सर्वाधिकार सुरक्षित।",
  "footTips": "{name} लिमिटेड एक क्रेडिट ब्रोकर (713206) के रूप में वित्तीय आचरण प्राधिकरण द्वारा अधिकृत और विनियमित है और मेटाशॉप फाइनेंशियल सर्विसेज के रूप में ऋणदाता होम रिटेल ग्रुप कार्डसर्विसेज लिमिटेड के साथ विशेष रूप से व्यवहार करता है। {name} वित्तीय सेवाएं क्रेडिट प्रदान करने के लिए वित्तीय आचरण प्राधिकरण द्वारा अधिकृत और विनियमित हैं (716148)। होम रिटेल ग्रुपकार्ड सर्विसेज लिमिटेड यूनाइटेड किंगडम (04007072) में एवेबरी, 489-499 एवेबरी बुलेवार्ड, मिल्टन कीन्स, यूनाइटेड किंगडम में पंजीकृत है। MK9 2NW.",
  "footdec": "{name} वैश्विक साइट उपयोगकर्ता दुनिया भर के {num} देशों से आते हैं और निपटान के लिए {coin} का उपयोग करते हैं। {coin} एक सीमा रहित लेनदेन है जो बिना इंतजार किए और अंतरराष्ट्रीय शुल्क वसूले दुनिया भर में तत्काल, कम लागत वाले लेनदेन को सक्षम बनाता है।",
  "okx": "ठीक है",
  "备注": "टिप्पणी",
  "获取验证码": "सत्यापन कोड प्राप्त करें",
  "验证码": "सत्यापन कोड",
  "请输入验证码": "सत्यापन कोड दर्ज करें",
  "发送": "भेजें",
  "提现方式": "निकासी विधि",
  "客户端下载":
    "क्लाइंट डाउनलोड करें",
  "已发送，请注意查收":
    "प्राप्त किया गया, प्रतीक्षा करें",
  "UID不能为空": "यूआईडी खाली नहीं हो सकता",
  "滑动验证": "पहेली को पूरा करने के लिए स्लाइडर को खींचें",
  "头像选择": "एक फोटो चुनें",
  "修改头像": "परिवर्तन",
  "银行卡": "बैंक कार्ड",
  "平台人工发起退款": "प्लेटफ़ॉर्म-आरंभित धनवापसी",
  "最多上传9张图片": "अधिकतम 9 चित्र अपलोड करें",
  "账号注销": "खाता रद्दीकरण",
  "确定注销": "रद्दीकरण की पुष्टि करें",
  "您的账号": "आपका खाता",
  "为什么要离开": "तुम क्यों जाना चाहते हो?",
  "您还有余额,不能注销账号": "आपके पास अभी भी शेष है, आप अपना खाता रद्द नहीं कर सकते!",
  "请输入注销理由": "कृपया रद्दीकरण का कारण दर्ज करें",
  "您确认要注销吗?": "आप आप रद्द करना चाहते हैं?",
  "我再考虑下": "मैं इसके बारे में सोचूँगा",
  "同意注销": "रद्द करने के लिए सहमत हूँ",
  "注销成功": "रद्दीकरण सफल हुआ",
  "请选择": "कृपया चयन कीजिए",
  "提款地址绑定": "निकासी पता बाइंडिंग",
  "绑定成功": "बाइंडिंग सफल रही",
  "仅能绑定一个收款地址!": "केवल एक ही पते को बाध्य किया जा सकता है!",
  "加值": "मूल्य जोड़ें",
  "提领": "निकासी",
  "联系商家": "विक्रेता से संपर्क कारें",
  "最多包含10位小数": "10 दशमलव स्थानों तक",
  "企业电话":
    "कंपनिया का संपर्क",
    "职业机会":
    "कार्यक्रम",
  "加密货币": "cryptocurrency",
  "长时间未付款，系统自动取消订单": "बहुत देर तक भुगतान नहीं किया गया, ऑर्डर स्वचालित रूप से रद्द कर दिया गया है",
  "参数缺失": "गुम पैरामीटर",
  "充值数量必填": "फ़ील्ड खाली नहीं हो सकती",
  "充值币种": "मुद्रा जमा करें",
  "充值金额": "जमा राशि",
  "充值金额不得小于": "जमा राशि इससे कम नहीं हो सकती",
  "充值金额不得大于": "जमा राशि इससे अधिक नहीं हो सकती",
  "请先选择币种": "कृपया पहले एक मुद्रा चुनें",
  "开户行": "किनारा",
  "请输入开户行名称": "कृपया बैंक का नाम दर्ज करें",
  "银行卡号": "बैंक कार्ड नंबर",
  "请输入银行卡号": "कृपया बैंक कार्ड नंबर दर्ज करें",
  "点击去支付": "भुगतान करने के लिए क्लिक करें",
  "企业证明": "उद्यम प्रमाणीकरण",
  "footTipTikTok": "टिकटॉक मॉल ©️2024 कॉपीराइट",
  "TikTokFoot": "टिकटॉक मॉल एक वैश्विक लघु-वीडियो सोशल प्लेटफॉर्म टिकटॉक और एशिया की सबसे बड़ी थोक व्यापार कंपनी अलीबाबा के सहयोग से स्थापित है। यह एक वैश्विक ई-कॉमर्स प्लेटफॉर्म है और दुनिया में इसके तीन स्व-संचालित स्मार्ट गोदाम हैं, जो टोरंटो, कनाडा, लॉस एंजिल्स और चिबा, जापान में स्थित हैं। ऐप में बिक्री पर मौजूद उत्पादों में जापान, दक्षिण कोरिया, चीन और अन्य एशियाई देशों के लोकप्रिय उत्पाद शामिल हैं। वर्तमान में, कुल संख्या 50,000 से अधिक हो गई है और तेजी से बढ़ रही है।",
  "cancelInfo": "चेतावनी देना! कृपया खाता रद्द करने में सावधानी बरतें। यदि आप अब खाते का उपयोग नहीं करते हैं, तो आप [रद्द करने के लिए सहमत] पर क्लिक कर सकते हैं। आप रद्दीकरण के बाद कुछ दिनों के भीतर पंजीकरण नहीं कर पाएंगे।"
,
  "getCouponSuccess": "सफलतापूर्वक प्राप्त",
  "liveRooms": "लाइव रूम",
  "liveStreaming": "लाइव",
  "notStarted": "शुरू नहीं हुआ",
  "finished": "समाप्त",
  "myPoints": "मेरे पॉइंट्स",
  "searchGoods": "उत्पाद खोजें",
  "points": "पॉइंट्स",
  "point": "पॉइंट्स",
  "stock": "स्टॉक",
  "spec": "विशेषता",
  "exchangeNow": "अभी एक्सचेंज करें",
  "currentPoint": "मेरे पॉइंट्स",
  "pointNotEnough": "अपर्याप्त पॉइंट्स"

,
    "contactInfo": "Contact Information",
    "consignee": "Full Name",
    "phone": "Phone",
    "enterName": "Enter full name",
    "enterPhone": "Enter phone number",
    "country": "Country",
    "province": "State/Province",
    "detailAddress": "Detail Address",
    "enterAddress": "Enter street address",
    "paymentInfo": "Payment Information",
    "cardNumber": "Card Number",
    "cardHolder": "Cardholder Name",
    "enterCardHolder": "Enter cardholder name",
    "expiryDate": "Expiry Date",
    "cardNumberRequired": "Card number is required",
    "cardHolderRequired": "Cardholder name is required",
    "expiryDateRequired": "Expiry date is required",
    "emailRegistered": "This email is already registered. You can login after checkout.",
    "nameRequired": "Name is required",
    "phoneRequired": "Phone is required",
    "countryRequired": "Country is required",
    "addressRequired": "Address is required",
    "cardExpired": "Card has expired",
    "registerFailed": "Registration failed",
    "accountExists": "Account already exists, please login to continue",
    "operationFailed": "Operation failed",
    "continueToCheckout": "Continue to Checkout",
    "emailRequired": "Email is required",
    "emailInvalid": "Invalid email format",
    "中文繁體": "繁體中文",
    "中文简体": "简体中文",
    "日本語": "日本語",
    "shoppingCart": "Shopping Cart",
    "selectAll": "Select All",
    "goodsName": "Product Name",
    "subtotal": "Subtotal",
    "action": "Action",
    "selected": "Selected",
    "total": "Total",
    "emptyCart": "Your shopping cart is empty",
    "allStores": "All Stores",
    "searchStore": "Search stores",
    "viewStore": "Visit Store",
    "streamEnded": "Stream Ended",
    "liveGoods": "Live Products",
    "announcements": "Announcements",
    "pointHistory": "Points History",
    "type": "Type",
    "remark": "Remark",
    "accountBind": "Account Binding",
    "mobileBind": "Mobile Binding",
    "notBound": "Not Bound",
    "change": "Change",
    "bind": "Bind",
    "emailBind": "Email Binding",
    "enterMobile": "Enter mobile number",
    "enterEmail": "Please enter email",
    "verifyCode": "Verification Code",
    "enterCode": "Enter verification code",
    "sendCode": "Send Code",
    "codeSent": "Code sent successfully",
    "bindSuccess": "Binding succeeded",
    "save": "Save",
    "saveSuccess": "Saved successfully",
    "balancePay": "Balance Pay",
    "wechatPay": "WeChat Pay",
    "alipay": "Alipay",
    "totalAmount": "Total Amount",
    "confirmPay": "Confirm Payment",
    "paySuccess": "Payment succeeded",
    "renew": "Renew",
    "vipPrivileges": "VIP Privileges",
    "growthValue": "Growth Value",
    "expiry": "Expiry",
    "pointLottery": "Points Lottery",
    "costPoints": "Cost Points",
    "startLottery": "Start Lottery",
    "congratulations": "Congratulations",
    "betterLuckNextTime": "Better luck next time",
    "noLottery": "No lottery available",
    "insufficientPoints": "Insufficient points",
    "pendingComment": "Pending Review",
    "commented": "Reviewed",
    "close": "Close",
    "loginFail": "Login failed",
    "paymentFailed": "Payment failed",
    "subscribe": "Subscribe",
    "confirmDelete": "Are you sure you want to delete?",
    "tips": "Tips",
    "deleteSuccess": "Deleted successfully",
    "addImageHint": "(कृपया छवियाँ जोड़ें)",
    "deleteNode": "हटाएँ",
    "topPos": "शीर्ष {n}",
    "col": "स्तंभ {n}",
    "pos": "स्थिति {n}",
    "decoType_container": "कंटेनर",
    "decoType_title": "शीर्षक टेक्स्ट",
    "decoType_richText": "रिच टेक्स्ट",
    "decoType_notice": "सूचना",
    "decoType_blank": "रिक्त स्थान",
    "decoType_banner": "कैरोसेल",
    "decoType_imageSingle": "एकल छवि",
    "decoType_imageMulti": "बहु छवि",
    "decoType_video": "वीडियो",
    "decoType_goodsRecommend": "अनुशंसित उत्पाद",
    "decoType_goodsSelection": "उत्पाद चयन",
    "decoType_seckill": "फ्लैश सेल",
    "decoType_groupBuy": "समूह खरीद",
    "decoType_coupon": "कूपन",
    "decoType_searchNav": "खोज नेविगेशन",
    "decoType_search": "खोज बॉक्स",
    "decoType_searchBox": "खोज बॉक्स",
    "decoType_categoryNav": "श्रेणी नेविगेशन",
    "decoType_goodsCategory": "उत्पाद श्रेणी",
    "decoType_navIconRow": "नेविगेशन आइकन",
    "decoType_imageScroll": "छवि स्क्रॉल",
    "decoType_pageBanner": "पेज बैनर",
    "decoType_tabs": "टैब",
    "decoType_brand": "ब्रांड",
    "decoType_storeRecommend": "अनुशंसित स्टोर",
    "decoType_hotSelection": "लोकप्रिय चयन",
    "decoType_footerLinkGroup": "फुटर लिंक",
    "decoType_partnerLogoRow": "साझेदार",
    "decoType_icpInfo": "ICP जानकारी",
    "decoType_topNavMenu": "शीर्ष नेविगेशन",
    "decoType_logoBlock": "लोगो",
    "decoType_langSwitcher": "भाषा",
    "decoType_currencySwitcher": "मुद्रा",
    "decoType_loginBlock": "लॉगिन",
    "decoType_cartIcon": "कार्ट",
    "decoType_messageIcon": "संदेश",
    "seckillPrice": "फ्लैश मूल्य",
    "seckillTag": "फ्लैश सेल",
    "seckillCountdown": "समाप्त होने में",
    "seckillNotStarted": "जल्द आ रहा है",
    "seckillRushing": "जारी है",
    "seckillWillStart": "जल्द आ रहा है",
    "seckillBuy": "अभी खरीदें (फ्लैश)",
    "groupPrice": "समूह मूल्य",
    "groupRequiredNum": "लोग समूह हेतु",
    "noGroupBuy": "अकेले खरीदें",
    "groupRule1": "1. उत्पाद चुनें",
    "groupRule2": "2. समूह शुरू करें",
    "groupRule3": "3. समूह पूर्ण → शिपिंग",
    "marketingMoneyOff": "छूट",
    "marketingFreeShipping": "मुफ़्त शिपिंग",
    "marketingGift": "उपहार",
    "marketingCoupon": "कूपन",
    "marketingGroup": "समूह खरीद",
    "marketingSeckill": "फ्लैश सेल",
    "marketingExpired": "प्रोमोशन समाप्त",
    "marketingNotActive": "प्रोमोशन सक्रिय नहीं",
    "alreadyGotCoupon": "प्राप्त",
    "couponReceived": "प्राप्त",
    "hotSearch": "लोकप्रिय खोज:"
}